export * from './GlobalStyles.styles';
